import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { RxStateComponent } from '@alliance/shared/models'

import { ClubUserProfile } from '@alliance/clubs/domain'
import { Environment } from '@alliance/shared/environment'

@Component({
  selector: 'alliance-clubs-author',
  templateUrl: './author.component.html',
  styleUrls: ['./author.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorComponent extends RxStateComponent<{
  userProfile: ClubUserProfile | null
  avatarImgSize: number
  spacingBetween: number
  direction: 'col' | 'row'
  separator: string
  fullNameStyle: 'bold' | 'normal'
}> {
  public state = this.connectViewState(['userProfile', 'avatarImgSize', 'spacingBetween', 'direction', 'separator', 'fullNameStyle'])

  public constructor(public env: Environment) {
    super()
    this.initState({
      userProfile: null,
      avatarImgSize: 20,
      spacingBetween: 10,
      direction: 'row',
      separator: '',
      fullNameStyle: 'normal'
    })
  }

  @Input()
  public set userProfile(value: ClubUserProfile | null) {
    this.set({ userProfile: value })
  }
  @Input()
  public set avatarImgSize(value: number) {
    this.set({ avatarImgSize: value })
  }
  @Input()
  public set spacingBetween(value: number) {
    this.set({ spacingBetween: value })
  }
  @Input()
  public set direction(value: 'col' | 'row') {
    this.set({ direction: value })
  }
  @Input()
  public set separator(value: string) {
    this.set({ separator: value })
  }
  @Input()
  public set fullNameStyle(value: 'bold' | 'normal') {
    this.set({ fullNameStyle: value })
  }
}
